import { QueryResponse } from '@/modules/queryfilter/domain/interfaces';
import { useQuery } from 'react-query';

export function useOptionsQuery(queryKey: string[]) {
  const query = useQuery<QueryResponse<Option>>(queryKey);

  return query;
}
